import {ContentLabSubscription} from '@/types/models/pricing/contentLabSubscription';
import contentStudioSubscriptionFetchers from '@/api/fetchers/content-studio/subscription';
import useBrandId from '@/hooks/use-brand-id';
import useReactQuery from '@/hooks/use-react-query';
import {CONTENT_LAB, CURRENT_SUBSCRIPTION} from '../consts';

type Response = {
  ltid: string;
  subscriptions: ContentLabSubscription[];
};

function useCurrentSubscriptionQuery(isEnabled = true) {
  const brandId = useBrandId();

  const response = useReactQuery<Response>({
    queryKey: [CONTENT_LAB, CURRENT_SUBSCRIPTION, brandId],
    queryFn: contentStudioSubscriptionFetchers.current,
    enabled: !!brandId && isEnabled,
  });

  const currentSubscriptions = response.data;

  return {
    ...response,
    currentSubscriptions,
    isCurrentSubscriptionDataFetched: response.isFetched,
  };
}

export default useCurrentSubscriptionQuery;
